const MainTheStarterKit = function() {
    function MainTheStarterKit() {
        this.selector = {
            productdetails: document.querySelectorAll('.product-details-btn'),
            productdetailsmodal: document.getElementById('product-details-modal'),
            productdetailsmodaloverlay: document.getElementById('product-details-modal-overlay'),
            modalclose: document.getElementById('product-details-modal-close'),
            steponevariantselected: document.getElementById('step-one-variant-selected'),
            steptwovariantselected: document.getElementById('step-two-variant-selected'),
            addtowizard: document.querySelectorAll('.add-to-wizard'),
            addtowizardone: document.querySelectorAll('.step-one-container .add-to-wizard'),
            addtowizardtwo: document.querySelectorAll('.step-two-container .add-to-wizard'),
            kitclose: document.querySelectorAll('.wizard-container > .variant-selection .kit-close'),
            steponecontainer: document.getElementById("step-one-container"),
            steptwocontainer: document.getElementById("step-two-container"),
            starterkitaddtocart: document.getElementById("starter-kit-add-to-cart"),
            sellingplanoptionsselect: document.getElementById("selling-plan-options-select"),
            stepsbuilderstepone: document.getElementById("steps-builder-step-one"),
            stepsbuildersteptwo: document.getElementById("steps-builder-step-two"),
            sellingplansubscriptionselection: document.getElementsByName("selling_plan_subscription_selection"),
            complimentaryselected: document.getElementById("complimentary-selected"),
            mobilecollapsablearrow: document.getElementById("mobile-collapsable-arrow"),
            secondvariantselecteditems: document.querySelector("#second-variants-selected-items .step-two-variant-selected"),
            highlightcountscontainer: document.getElementById("highlight-counts-container"),
            highlightscentrunningscount: document.getElementById("highlight-scents-running-count"),
            highlightscentsmaxcount: document.getElementById("highlight-scents-max-count")
        }
        this.state = {
            step_one: [],
            step_two: [],
            filteredVariantSellingPlan: [],
            variantSizeLimit: 0,
            variantRunningCount: 0 
        }
        this.final = {
            withsubscription_el: document.getElementById("final-with-subscription"),
            onetimepurchase_el: document.getElementById("final-one-time-purchase"),
            first_product_price: 0,
            second_product_price: 0,
            first_product_discount_price: 0,
            second_product_discount_price: 0,
            total_discounted_price_el: document.getElementById("final-discounted-price"),
            total_regular_price_el: document.getElementById("final-cross-out-price"),
            current_currency: '$',
            subscription_plan: null,
            first_variant_id: null,
            second_variants: [],
            first_variant_available: false
        }
        this.load();
    }
    MainTheStarterKit.prototype.load = function() {
        var _ = this;
        if(_.selector.productdetails.length > 0) {
            _.selector.productdetails.forEach(btn => {
                btn.addEventListener('click', event => {
                    const templateContent = event.target.closest('.image').querySelector(`#product-details-${event.target.closest('button').dataset.templateId}`).content;
                    _.selector.productdetailsmodal.querySelector(".render").innerHTML = "";
                    _.selector.productdetailsmodal.querySelector(".render").appendChild(document.importNode(templateContent, true));
                    _.selector.productdetailsmodal.classList.add('active');
                    _.selector.productdetailsmodaloverlay.classList.add('active');
                })
            })
        }
        if(_.selector.modalclose) {
            _.selector.modalclose.addEventListener('click', () => {
                _.selector.productdetailsmodal.classList.remove('active');
                _.selector.productdetailsmodaloverlay.classList.remove('active');
            })
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(btn => {
                btn.addEventListener('click', event => {
                    document.querySelector('.selling-plan-subscription').click();
                    if(event.target.closest('button').dataset.stepsNumber === 'one') {
                        var variantImage = document.createElement('img');
                        variantImage.src = event.target.closest('button').dataset.variantImage;
                        variantImage.alt = event.target.closest('button').dataset.variantTitle;
                        variantImage.width = "125";
                        variantImage.height = "125";
                        _.selector.steponevariantselected.querySelector('.kit-close').classList.add("active");
                        _.selector.steponevariantselected.querySelector('.image').innerHTML = "";
                        _.selector.steponevariantselected.querySelector('.image').appendChild(variantImage);      
                        _.selector.steponevariantselected.querySelector('.selected-details').classList.add('active');
                        _.selector.steponevariantselected.querySelector('.selected-details .title').textContent = event.target.closest("button").dataset.variantTitle.split(' / ')[0];
                        const ExtactVariantSize = event.target.closest("button").dataset.refinedVariantTitle.match(/\d+/g);
                        _.state.variantSizeLimit = 1;
                        _.selector.steponevariantselected.querySelector('.selected-details .pricing .regular').textContent = event.target.closest("button").dataset.compareAtPrice;
                        if(parseInt(event.target.closest("button").dataset.refinedDiscountedPrice) != parseInt(event.target.closest("button").dataset.refinedRegularPrice)) {
                            _.selector.steponevariantselected.querySelector('.selected-details .pricing .compare-at-price').textContent = event.target.closest("button").dataset.regularPrice;                        
                        }
                        _.state.step_one.push({variantId: event.target.closest('button').dataset.variantId, regularPrice: event.target.closest('button').dataset.regularPrice, stepNumber: event.target.closest('button').dataset.stepsNumber, variantTitle: event.target.closest('button').dataset.refinedVariantTitle});
                        _.final.first_product_price = parseInt(event.target.closest('button').dataset.refinedRegularPrice);
                        _.final.first_product_discount_price = parseInt(event.target.closest('button').dataset.refinedDiscountedPrice);
                        _.final.current_currency = event.target.closest('button').dataset.currentCurrency;
                        _.final.first_variant_id = event.target.closest('button').dataset.variantId;
                        _.selector.steptwocontainer.scrollIntoView({behavior: 'smooth', block: 'start'});
                        _.recalculate();
                    }
                    if(event.target.closest('button').dataset.stepsNumber === 'two') {            
                        _.state.filteredVariantSellingPlan = [];
                        _.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === event.target.closest("button").dataset.variantId);
                        if(_.state.filteredVariantSellingPlan.length > 0) {      
                            if(_.selector.sellingplanoptionsselect) {
                                _.selector.sellingplanoptionsselect.innerHTML = "";
                                let loopIndex = 0;
                                for (const option of _.state.filteredVariantSellingPlan) {
                                    var selling_plan_option = document.createElement("option");
                                    selling_plan_option.value = option.sellingPlanId;
                                    selling_plan_option.text = option.sellingPlanName;
                                    selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
                                    selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
                                    selling_plan_option.dataset.variantId = option.variantId;
                                    selling_plan_option.dataset.variantPrice = option.variantPrice;
                                    selling_plan_option.dataset.currentCurrency = option.currentCurrency;
                                    selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
                                    loopIndex == 0 && (selling_plan_option.selected = true);
                                    loopIndex == 0 && (_.final.subscription_plan = option.sellingPlanId);
                                    _.selector.sellingplanoptionsselect.append(selling_plan_option);
                                    loopIndex++;
                                }      
                                _.selector.sellingplanoptionsselect.classList.add('active');                         
                            }                            
                        }                        
                        _.selector.starterkitaddtocart.classList.add("active");
                        _.final.second_product_price = parseInt(event.target.closest('button').dataset.refinedPrice);
                        _.final.second_product_discount_price = parseInt(event.target.closest('button').dataset.refinedDiscountedPrice);
                        _.final.withsubscription_el.textContent = `${_.final.current_currency}${(_.final.second_product_discount_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        // to remove the decimals if the price doesn't have any
                        if (_.final.withsubscription_el.textContent.slice(-2) == '00') {
                            _.final.withsubscription_el.textContent = `${_.final.current_currency}${(_.final.second_product_discount_price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        }
                        _.final.onetimepurchase_el.textContent = `${_.final.current_currency}${(_.final.second_product_price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        if(!_.final.second_variants.includes(event.target.closest('button').dataset.variantId)) {
                            _.final.second_variants.push(event.target.closest('button').dataset.variantId);
                            _.state.variantRunningCount = _.state.variantRunningCount + 1;
                        }                        
                        const addednewscents = document.createElement("div");
                        addednewscents.classList.add("step-two-variant-selected");
                        addednewscents.classList.add("active");
                        addednewscents.dataset.variantId = event.target.closest('button').dataset.variantId;
                        addednewscents.dataset.variantTitle = event.target.closest('button').dataset.variantTitle;
                        addednewscents.innerHTML = `<button type="button" class="kit-close active" data-selected-title="Select an Oil">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.59715 10.4031L10.4031 3.59716M3.59722 3.6531L10.3472 10.4031" stroke="black" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
                        <div class="image"><img src="${event.target.closest('button').dataset.variantImage}" alt="${event.target.closest('button').dataset.variantTitle}" width="125" height="125"></div>
                        <div class="selected-details active"><span class="title">${event.target.closest('button').dataset.variantTitle}</span><span class="pricing">
                        <span class="regular">${event.target.closest('button').dataset.compareAtPrice}</span>
                        <span class="compare-at-price">${event.target.closest('button').dataset.regularPrice}</span></span></div>`;
                        _.selector.steptwovariantselected.classList.remove("active");
                        _.selector.steptwovariantselected.after(addednewscents);
                        // _.selector.secondvariantselecteditems.append(addednewscents);
                        _.state.step_two.push(event.target.closest('.item'));
                        _.recalculate();
                        if (window.innerWidth < 1025) {
                            document.querySelector('.steps-wizard').classList.add('active');
                            let scrollingSection = document.querySelector('.main-the-starter-kit');
                            scrollingSection.scrollTo({
                                top: scrollingSection.scrollHeight,
                                behavior: 'smooth'
                            });
                        } else {
                            window.scrollTo({top: top, behavior: 'smooth'});
                        }
                        document.querySelector('.step-two-variant-selected .kit-close.active').addEventListener('click', event => {
                            _.final.second_variants = [];
                            _.state.step_two = [];
                            _.final.withsubscription_el.textContent = '';
                            _.final.onetimepurchase_el.textContent = '';
                            event.target.closest(".step-two-variant-selected").remove();
                            document.querySelector('.step-two-variant-selected.initial').classList.add('active');
                            _.state.variantRunningCount = _.state.variantRunningCount - 1;
                            _.recalculate();      
                        })
                    }
                })
            })
        }
        if(_.selector.kitclose.length > 0) {
            _.selector.kitclose.forEach(close => {
                close.addEventListener('click', event => {
                    if(event.target.closest('.step-one-variant-selected')) {
                        event.target.closest('.step-one-variant-selected').querySelector('.image').innerHTML = "";
                        event.target.closest('button').classList.remove('active');
                        var spantext = document.createElement('span');
                        spantext.classList.add('label');
                        spantext.textContent =  event.target.closest('button').dataset.selectedTitle;
                        event.target.closest('.step-one-variant-selected').querySelector('.image').appendChild(spantext);
                        event.target.closest('.step-one-variant-selected').querySelector('.selected-details').classList.remove('active');
                        _.selector.steponecontainer.scrollIntoView({behavior: 'smooth', block: 'start'});     
                        _.state.step_one = [];
                        /*
                        _.final.second_variants = [];
                        _.state.variantRunningCount = 0;
                        _.selector.highlightcountscontainer.classList.remove("active");
                        const steptwovariantselected = document.querySelectorAll(".step-two-variant-selected");
                        if(steptwovariantselected.length > 0) {
                            Array.from(steptwovariantselected).map(el => {
                                if(el.classList.contains("active") && !el.classList.contains("initial")) {
                                    el.remove();
                                }
                                if(el.classList.contains("initial")) {
                                    el.classList.add("active");
                                }
                            })
                        }
                        */
                        _.recalculate();                
                    } 
                })
            })
        }
        if(_.selector.sellingplansubscriptionselection.length > 0) {
            _.selector.sellingplansubscriptionselection.forEach(el => {
                el.addEventListener("change", event => {
                    _.selector.sellingplansubscriptionselection.forEach(selection => {
                        selection.closest("label").classList.remove("active");
                    });
                    event.target.closest("label").classList.add("active");
                    if(event.target.value !== "one-time-purchase") {
                        _.final.subscription_plan = _.selector.sellingplanoptionsselect.options[_.selector.sellingplanoptionsselect.selectedIndex].dataset.sellingPlanId;
                        _.final.total_regular_price_el.style.textDecoration = "line-through";
                        _.final.total_regular_price_el.style.opacity = "0.4";
                        _.final.total_discounted_price_el.style.display = "inline";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.textDecoration = "line-through";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.display = "block";
                        document.querySelector('.step-two-variant-selected.active .regular').style.display = "block";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.opacity = "0.4";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.fontWeight = "400";
                    } else {
                        _.final.subscription_plan = "one-time-purchase";
                        _.final.total_discounted_price_el.style.display = "none";
                        _.final.total_regular_price_el.style.textDecoration = "none";
                        _.final.total_regular_price_el.style.opacity = "1";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.textDecoration = "none";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.opacity = "1";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.fontWeight = "600";
                        document.querySelector('.step-two-variant-selected.active .regular').style.display = "none";
                    }
                })
            })
        }
        if(_.selector.sellingplanoptionsselect) {
            _.selector.sellingplanoptionsselect.addEventListener("change", event => {
                document.querySelector('.selling-plan-subscription').click();
                _.final.subscription_plan = event.target.value;
                _.selector.steptwovariantselected.querySelector('.selected-details .selling-plan').textContent = event.target.options[event.target.selectedIndex].text;
            })
        }
        if(_.selector.mobilecollapsablearrow) {
            _.selector.mobilecollapsablearrow.addEventListener("click", event => {
                event.target.closest(".steps-wizard").classList.toggle("active");
            })
        }
        if(_.selector.secondvariantselecteditems) {
            _.selector.secondvariantselecteditems.addEventListener("click", event => {
                _.final.second_variants = event.target.closest(".step-two-variant-selected") ? _.final.second_variants.filter(variant => variant !== event.target.closest(".step-two-variant-selected").dataset.variantId) : [];
                _.state.step_two = event.target.closest(".step-two-variant-selected") ? _.state.step_two.filter(item => item.dataset.variantId !== event.target.closest(".step-two-variant-selected").dataset.variantId) : [];

                if(event.target.closest(".step-two-variant-selected") && !event.target.closest(".step-two-variant-selected").classList.contains("initial")) {
                    _.final.withsubscription_el.textContent = '';
                    _.final.onetimepurchase_el.textContent = '';
                    event.target.closest(".step-two-variant-selected").remove();
                    _.state.variantRunningCount = _.state.variantRunningCount - 1;
                } else {
                    return
                }
                if(_.final.second_variants.length == 0) {
                    _.selector.steptwovariantselected.classList.add("active");
                    _.state.variantRunningCount = 0;
                    _.selector.steptwocontainer.scrollIntoView({behavior: 'smooth', block: 'start'});  
                }
                _.recalculate();
            })
        }
        if(_.selector.starterkitaddtocart) {
            _.selector.starterkitaddtocart.addEventListener("click", () => {
                _.addtocart();
            })
        }
    }
    MainTheStarterKit.prototype.recalculate = function() {
        var _ = this;
        if(_.state.step_one.length > 0) {
            _.selector.stepsbuilderstepone.classList.add("disabled");           
            _.selector.highlightcountscontainer.classList.add("active");
            _.selector.highlightscentrunningscount.textContent = `${_.state.variantRunningCount}`;
            _.selector.highlightscentsmaxcount.textContent = `${_.state.variantSizeLimit}`;           
        } else {
            _.selector.stepsbuilderstepone.classList.remove("disabled");
            _.selector.highlightcountscontainer.classList.remove("active");
            _.selector.highlightscentrunningscount.textContent = ``;
            _.selector.highlightscentsmaxcount.textContent = ``;
        }
        if(_.state.step_one.length > 0 && _.final.second_variants.length > 0) {
            const final_first_discounted_price = (parseInt(_.final.first_product_discount_price) + parseInt(_.final.second_product_discount_price)) / 100;
            const final_total_discounted_price = final_first_discounted_price;
            const final_first_regular_price = (parseInt(_.final.first_product_price) + parseInt(_.final.second_product_price)) / 100;
            const final_total_regular_price = final_first_regular_price;
            _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            // to remove the decimals if the price doesn't have any
            if (_.final.total_discounted_price_el.textContent.slice(-2) == "00") {
                _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            if(final_total_discounted_price != final_first_regular_price) {
                _.final.total_regular_price_el.textContent = `${_.final.current_currency}${final_total_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.closest(".item").classList.remove("selected", "disabled");
                wizard.closest(".item button").classList.remove("disabled");
            })
        }
        if(_.state.step_two.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.closest(".item").classList.add("disabled");
            })
            _.state.step_two.forEach(step => {
                step.querySelector(".add-to-wizard").setAttribute('disabled', 'disabled');
                step.classList.add("selected");
                step.classList.remove("disabled");
            })
        } else {
            _.selector.addtowizard.forEach(wizard => {
                wizard.removeAttribute('disabled');
            })
        }
        if(window.diffUserVariants.length > 0 && _.state.step_one.length > 0) {
            const currentSelectedColor = _.state.step_one[0].variantTitle.split(" / ");
            let diffUserVariants = window.diffUserVariants.filter(variant => variant.variantTitle.includes(currentSelectedColor[0]));
            diffUserVariants = diffUserVariants.sort((a,b) => a.value - b.value);
            let notYetFoundHighestNumber = true;
            diffUserVariants.map(variant => {
                const splitVariantTitle = variant.variantTitle.split(" / ");
                if(notYetFoundHighestNumber && parseInt(_.state.variantRunningCount) <= parseInt(splitVariantTitle[1])) {
                    _.state.variantSizeLimit = 1;
                    notYetFoundHighestNumber = false;                        
                    _.final.first_variant_id = variant.variantId;
                    _.final.first_variant_available = variant.variantAvailable === "true" ? true : false;
                    const variantSplitValue = variant.variantTitle.split(" / ");
                    _.selector.highlightscentsmaxcount.textContent = `${variantSplitValue[1]}`;
                    _.selector.steponevariantselected.querySelector('.selected-details .title').textContent = variant.productTitle.split(' / ')[0];
                    _.selector.steponevariantselected.querySelector('.selected-details .pricing .regular').textContent = variant.variantPrice;
                    _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
                }
            })
        }
        if(_.state.variantRunningCount == 1 && _.state.step_one.length > 0) {
            _.selector.starterkitaddtocart.disabled = false;
        } else {
            _.selector.starterkitaddtocart.disabled = true;
        }
        _.removeTryNowSellingPlan();
    }
    MainTheStarterKit.prototype.addtocart = async function() {
        var _ = this;
        var formData;
        if(_.selector.complimentaryselected && _.selector.complimentaryselected.dataset.variantAvailable == "true") {
            if(_.final.subscription_plan !== "one-time-purchase") {
                formData = {
                    'items': [
                        {
                            'id': parseInt(_.final.first_variant_id),
                            'quantity': 1
                        },
                        {
                            'id': parseInt(_.selector.complimentaryselected.dataset.variantId),
                            'quantity': 1
                        },
                        {
                            'id': parseInt(_.final.second_variants[0]),
                            'quantity': 1,
                            'selling_plan': parseInt(_.final.subscription_plan)
                        }
                    ],
                    'attributes': {
                        'Starter Kit': 'True'
                    }
                };
            } else {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.selector.complimentaryselected.dataset.variantId),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                            }
                    ],
                    'attributes': {
                        'Starter Kit': 'True'
                    }
                    };
            }
        } else {
            if (_.final.subscription_plan !== "one-time-purchase") {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                                'selling_plan': parseInt(_.final.subscription_plan)
                            }
                        ],
                        'attributes': {
                            'Starter Kit': 'True'
                        }
                    };
            } else {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                            }
                        ],
                        'attributes': {
                            'Starter Kit': 'True'
                        }
                    };
            }
        }
        _.selector.starterkitaddtocart.setAttribute('disabled', 'disabled');
        _.selector.starterkitaddtocart.querySelector('.text-line').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.pricing').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.remove('hide');
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
            return response.json();
        })
        .then(data => {
        })
        .catch((error) => {
            console.error('Error:', error);
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
        });           
    }
    MainTheStarterKit.prototype.removeTryNowSellingPlan = function() {
        var _ = this;
        if(_.state.step_one && _.state.step_one.length > 0 || _.state.step_two && _.state.step_two.length > 0) {
            //code to remove trynow selling plan on safari
            const trynowOption = document.querySelectorAll("option[data-selling-plan-id='4571005184']");
            if (trynowOption && trynowOption.length > 0) {
                trynowOption.forEach((item) => {
                    item.remove();
                })
            }
            //code to remove trynow selling plan on safari
        }
    }
    MainTheStarterKit = new MainTheStarterKit;
}
MainTheStarterKit();